import React from 'react';

import { usePromoCart } from '../../../../../../contexts/PromoCartProvider';
import { NumProducts } from '../NumProducts/NumProducts';

export const MsbSecondaryMessaging = () => {
  const { promoSuccessLevel } = usePromoCart();

  return (
    <>
      <span>Any combination <NumProducts /></span>
      {promoSuccessLevel === 'almost' && (
        <span className="promo-messaging-container__large-screen-text">
          <span>  |  </span>
          <span className="u__bold">Almost There!</span>
        </span>
      )}
    </>
  );
};

MsbSecondaryMessaging.displayName = 'MsbSecondaryMessaging';
